var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "184 -776 592 592",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.62-184q-24.32 0-40.47-16.15T184-240.62v-478.76q0-24.32 16.15-40.47T240.62-776h478.76q24.32 0 40.47 16.15T776-719.38v478.76q0 24.32-16.15 40.47T719.38-184zm0-32h130.3v-154.92H216v130.3q0 10.77 6.92 17.7 6.93 6.92 17.7 6.92m162.3 0h154.16v-154.92H402.92zm186.16 0h130.3q10.77 0 17.7-6.92 6.92-6.93 6.92-17.7v-130.3H589.08zM216-402.92h154.92v-154.16H216zm186.92 0h154.16v-154.16H402.92zm186.16 0H744v-154.16H589.08zM216-589.08h154.92V-744h-130.3q-10.77 0-17.7 6.92-6.92 6.93-6.92 17.7zm186.92 0h154.16V-744H402.92zm186.16 0H744v-130.3q0-10.77-6.92-17.7-6.93-6.92-17.7-6.92h-130.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridOn);
export default __webpack_public_path__ + "static/media/grid_on.4136608a0c0d1795efeaa9afbc5e171d.svg";
export { ForwardRef as ReactComponent };